// extracted by mini-css-extract-plugin
export default {"supplier-supplier-code-header":"XaDMjTzuKqUtcxpCoJ7t"};